/**
 * @desc 保存
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.LogisticsGroupDetailsResponseDto>;
export function request(
  body: defs.basics.LogisticsGroupAttrRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/logisticsGroupAttr/save`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
